import { Card, Stack } from '@leroy-merlin-br/backyard-react'

import * as S from './styled'

const PixDisclaimerCard = () => (
  <Card target="card" shadow="triple">
    <Stack space="giga">
      <S.GreenBlock>
        <S.Title>Pagar com o PIX é simples, rápido e seguro</S.Title>
        <S.List>
          <S.ListItem>
            Tão simples que com a câmera do celular você consegue realizar o
            pagamento!
          </S.ListItem>
          <S.ListItem>
            Tão rápido que nós confirmamos seu pagamento dentro de 15 segundos.
          </S.ListItem>
          <S.ListItem>
            E o melhor, como o PIX é instantâneo o prazo de entrega começa a
            contar imediatamente após o pagamento
          </S.ListItem>
        </S.List>
      </S.GreenBlock>

      <S.GrayBlock>
        <S.Section>
          <S.Title>Mas atenção!</S.Title>
          <S.OrderedList>
            <S.ListItem>
              Quando você escolhe realizar o pagamento via PIX o valor do seu
              pedido não poderá ser parcelado.
            </S.ListItem>
            <S.ListItem>
              Para a sua segurança, geramos códigos Pix exclusivos para cada
              pedido. Então, caso você não consiga realizar o pagamento até a
              expiração do código, não se preocupe, faremos o cancelamento
              automático.
            </S.ListItem>
            <S.ListItem>
              Em casos de cancelamento por expiração do código, você pode tentar
              repetir a compra. Nosso site estará sempre disponível para você
              realizar um novo pedido.
            </S.ListItem>
          </S.OrderedList>
        </S.Section>

        <div>
          <S.Title>Para acesso</S.Title>
          <S.Paragraph>
            Você também poderá acessar o seu código PIX desse pedido através da
            página &quot;Meus Pedidos&quot; ou nas comunicações enviadas por
            e-mail.
          </S.Paragraph>
        </div>
      </S.GrayBlock>
    </Stack>
  </Card>
)

export default PixDisclaimerCard
